import React from 'react';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { ARCHIVE_PROJECT } from '../../../graphql/ARCHIVE_PROJECT';

interface IArchiveProject {
  projectId: string;
  projectAuthorId?: string;
  currentUserId?: string;
  isArchived: boolean;
  onArchiveComplete?: () => void;
}

const ArchiveProject: React.FC<IArchiveProject> = ({
  projectId,
  projectAuthorId,
  currentUserId,
  isArchived,
  onArchiveComplete
}) => {
  const [archiveProject, { loading }] = useMutation(ARCHIVE_PROJECT, {
    variables: { projectId },
    refetchQueries: ['GET_ALL_PROJECTS_BY_USER'],
    update(cache, { data }) {
      if (data?.archiveProject) {
        cache.modify({
          id: cache.identify({ __typename: 'Project', id: projectId }),
          fields: {
            isArchived() {
              return data.archiveProject.isArchived;
            }
          }
        });
      }
    },
    onCompleted: (data) => {
      const newArchivedState = data?.archiveProject?.isArchived;
      const message = newArchivedState
        ? 'Project archived successfully'
        : 'Project is now public and visible to everyone!';
      toast.success(message);

      if (onArchiveComplete) {
        onArchiveComplete();
      }
    },
    onError: (error) => {
      const action = isArchived ? 'unarchive' : 'archive';
      toast.error(`Failed to ${action} project: ${error.message}`);
    }
  });

  // Early return if not the project author
  if (projectAuthorId !== currentUserId) {
    return null;
  }

  const buttonText = loading
    ? 'Processing...'
    : isArchived
      ? 'Unarchive Project'
      : 'Archive Project';

  return (
    <button
      onClick={async () => await archiveProject()}
      disabled={loading}
      className={`dropdown-item dropdown-item--archive-button ${loading ? 'is-disabled' : ''}`}
    >
      {buttonText}
    </button>
  );
};

export default ArchiveProject;